export default "__VITE_ASSET__C1IScDTM__"